/**
 * @generated SignedSource<<ef71bc70f09cf311ee4499d894759c48>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type courseQuiz_quiz$data = {
  readonly completed: boolean;
  readonly course: {
    readonly slug: string;
    readonly " $fragmentSpreads": FragmentRefs<"certificateEmitDialogFragment">;
  };
  readonly description: any | null | undefined;
  readonly id: string;
  readonly name: string;
  readonly nextClass: {
    readonly canAccess: boolean;
    readonly slug: string;
  } | null | undefined;
  readonly previousClass: {
    readonly canAccess: boolean;
    readonly slug: string;
  } | null | undefined;
  readonly quiz: {
    readonly id: string;
    readonly questions: ReadonlyArray<{
      readonly active: boolean;
      readonly description: any;
      readonly id: string;
      readonly options: ReadonlyArray<{
        readonly active: boolean;
        readonly id: string;
        readonly text: string;
      }>;
      readonly title: string;
    }>;
  };
  readonly slug: string;
  readonly " $fragmentType": "courseQuiz_quiz";
};
export type courseQuiz_quiz$key = {
  readonly " $data"?: courseQuiz_quiz$data;
  readonly " $fragmentSpreads": FragmentRefs<"courseQuiz_quiz">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "enabled",
    "value": "ACTIVE"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canAccess",
    "storageKey": null
  },
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "courseQuiz_quiz",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Quiz",
      "kind": "LinkedField",
      "name": "quiz",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": (v3/*: any*/),
          "concreteType": "QuizQuestion",
          "kind": "LinkedField",
          "name": "questions",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            (v2/*: any*/),
            (v4/*: any*/),
            {
              "alias": null,
              "args": (v3/*: any*/),
              "concreteType": "QuizQuestionOption",
              "kind": "LinkedField",
              "name": "options",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "text",
                  "storageKey": null
                }
              ],
              "storageKey": "options(enabled:\"ACTIVE\")"
            }
          ],
          "storageKey": "questions(enabled:\"ACTIVE\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Course",
      "kind": "LinkedField",
      "name": "course",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "certificateEmitDialogFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "nextClass",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "previousClass",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    }
  ],
  "type": "CourseQuiz",
  "abstractKey": null
};
})();

(node as any).hash = "079d2949601384c30d79387d70b0dba8";

export default node;
